import is from "is_js";
import formatDate from "../utils/formatDate";
import moment from 'moment';
import {enviarAnexo} from '../provider/anexos.service';

export class Pendency {
    dataHoraInicio = moment();
    horaFim = null;
    horaInicio = null;
    descricao = '';
    codigoClassificacaoHoras = 'NO';
    codigoTipoAtividade = 'PR';
    codTipoCapacitacao = null;
    tipoCapacitacao = null;
    opcoesCapacitacao = [];
}

export async function SendPendencyAsync(props = {}) {
    const pendency = {}
    if(is.not.empty(pendency.pendenciaId)) {
        pendency.pendenciaId = props.pendenciaId ?? null;
    } else {
        pendency.atividadeAlocada = props.atividadeAlocada;
        pendency.codigoProjeto = props.codigoProjeto;
        pendency.codigoSubsistema = props.codigoSubsistema;
    }
    pendency.dataHoraInicio = formatDate(props.dataHoraInicio);
    pendency.dataHoraFim = formatDate(props.dataHoraFim);
    pendency.descricao = props.descricao ?? '';
    pendency.codigoClassificacaoHoras = props.codigoClassificacaoHoras;
    pendency.codigoTipoAtividade = props.codigoTipoAtividade;
    pendency.atividadeAlocada = props.atividadeAlocada ?? null;
    pendency.codigoProjeto = props.codigoProjeto ?? null;
    pendency.caminhoArquivo = props.caminhoArquivo ?? null;
    pendency.codigoSubsistema = props.codigoSubsistema ?? null;
    pendency.idAtividadeAlocada = props?.idAtividadeAlocada ?? null;
    pendency.codTipoCapacitacao = props.codTipoCapacitacao ?? null;
    if(props.codigoTipoAtividade === 'FJ' && props.anexo){
        await enviarAnexo(props.anexo).then(({data}) => {
            pendency.caminhoArquivo = data;
            delete props.anexo
        }).catch(async (error) => {
            throw error;
        });
    } else if (props.codigoTipoAtividade !== 'FJ') {
        delete pendency.caminhoArquivo;
    }
    return pendency
}

export async function InitLastPendency(props){
        return {
            ...await SendPendencyAsync(props),
            dataHoraInicio: null,
            dataHoraFim: null,
            codTipoCapacitacao: null,
        };
}

export default new Pendency();
